export default {
  en: {
    ModifyIndexScene: {
      title: 'Modify orders',
    },
  },
};
